var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveTickIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#E3F4DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.5L8 11L12 6",
    stroke: "#52AE2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveTickIcon);
export default __webpack_public_path__ + "static/media/ActiveTickIcon.cfc9a3c752ce339acb2dd38bbfbd0152.svg";
export { ForwardRef as ReactComponent };